import CreateClassDialog from 'Pages/GMS/ISR/Components/CreateClassDialog';
import ModelFilter from 'Pages/GMS/ISR/Components/ModelFilter';
import { CREATE, FIELD, MANAGE_CLASS, SUB_MODEL } from 'Pages/GMS/ISR/ISRConstants';
import { AddIcon, XIcon } from 'assests/GmsIcons';
import React, { useEffect, useState } from 'react';
import ClassTable from '../Class/ClassTable';
import { getAllProjectClass } from '../ModelServices/ModalServices';
import { TFieldClass } from '../model';
import { toast } from 'react-toastify';
import { useISRContext } from 'Pages/GMS/ISR/Hooks/useISRContext';

type TManageClassDialogProps = {
    id: string;
    showClassMenu: boolean;
    setShowClassMenu: React.Dispatch<React.SetStateAction<boolean>>;
    projectId?: string | null | undefined;
}

const ManageClassDialog = ({id, showClassMenu: showConnectorMenu, setShowClassMenu: setShowConnectorMenu, projectId}: TManageClassDialogProps) => {
    const isrContext = useISRContext();
    const [showClassDialog, setShowClassDialog] = useState<boolean>(false);
    const [selectedFilter, setSelectedFilter] = useState<string>(SUB_MODEL);
    const initializeClass = { id: null, name: '', type: '', colour: '' };
    const [selectedClass, setSelectedClass] = useState<TFieldClass>(initializeClass);
    const toggleMenu = () => {
        setShowConnectorMenu(!showConnectorMenu);
    };

    useEffect(() => {
        fetchAllClasses();
    }, []);

    useEffect(() => {
        if (isrContext?.refreshCounter === 0) return;
        fetchAllClasses();
    }, [isrContext?.refreshCounter]);
    
    const fetchAllClasses = async () => {
        try {
            const responseData = await getAllProjectClass(projectId ?? '');
            if (responseData?.done) {
                isrContext?.setFieldClasses(responseData?.data?.fieldClasses ?? []);
                isrContext?.setModelClasses(responseData?.data?.modelClasses ?? []);
            } else {
                toast.error(responseData?.message);
            }
        } catch (error) {
            console.log('Error', error);
        } finally {

        }
    }

    const openClassDialog = () => setShowClassDialog(true);
    const closeClassDialog = () => setShowClassDialog(false);

    const overlayClasses = 'tw-absolute tw-inset-0 tw-bg-black tw-opacity-50 tw-z-40 tw-h-full tw-w-full';
    const menuClasses = showConnectorMenu
        ? 'tw-absolute tw-top-0 tw-right-0 tw-h-full tw-max-h-full tw-overflow-auto tw-w-1/2 tw-bg-white tw-z-50 tw-p-6 tw-shadow-lg'
        : 'tw-hidden';

        return (
            <div id={id} className="tw-h-[calc(100vh-60px)] tw-fixed tw-top-0 tw-left-0 tw-w-full tw-z-40 tw-mt-16">
                <div id={`${id}-overlay`} className={overlayClasses} onClick={toggleMenu} />
                <div id={`${id}-content`} className={menuClasses}>
                    <div id={`${id}-header`} className={`tw-flex tw-justify-between tw-items-center tw-border-b tw-py-3 tw-sticky tw-top-0 tw-bg-white tw-z-10`}>
                        <h2 id={`${id}-title`} className={`tw-text-[#091E42] tw-font-medium tw-text-sm`}>
                            {MANAGE_CLASS}
                        </h2>
                        <div id={`${id}-header-actions`} className='tw-flex tw-items-center tw-gap-5'>
                            <ModelFilter 
                                id={`${id}-model-filter`}
                                labels={[SUB_MODEL, FIELD]} 
                                selectedFilter={selectedFilter} 
                                setSelectedFilter={setSelectedFilter} 
                            />
                            <button 
                                id={`${id}-create-btn`}
                                onClick={() => {
                                    setSelectedClass(initializeClass); 
                                    openClassDialog();
                                }} 
                                className='button-style tw-flex tw-items-center tw-gap-1'
                            >
                                <AddIcon color="#fff"/>
                                {CREATE}
                            </button>
                            <button 
                                id={`${id}-close-btn`}
                                className={`tw-text-black`} 
                                onClick={toggleMenu}
                            >
                                <XIcon />
                            </button>
                        </div>
                    </div>
                    <ClassTable 
                        id={`${id}-class-table`}
                        fieldClasses={isrContext?.fieldClasses} 
                        modelClasses={isrContext?.modelClasses} 
                        selectedFilter={selectedFilter} 
                        projectId={projectId ?? ''} 
                        setRefreshCounter={isrContext?.setRefreshCounter} 
                        setSelectedClass={setSelectedClass} 
                        toggleMenu={openClassDialog}
                    />
                </div>
                {showClassDialog ? 
                    <CreateClassDialog 
                        id={`${id}-create-dialog`}
                        onClose={closeClassDialog} 
                        projectId={projectId ?? ''} 
                        setRefreshCounter={isrContext?.setRefreshCounter} 
                        selectedClass={selectedClass}
                    /> 
                : null}
            </div>
        );
}

export default ManageClassDialog;